import { ExtendedFieldProps } from "@atlaskit/inline-edit/dist/types/types";
import React, { useRef, useState } from "react";
import {ActionMeta, AsyncSelect, InputActionMeta, OptionsType, OptionType, ValueType} from "@atlaskit/select";
import { confluenceService } from "../../api/ConfluenceService";
import {SecurityService} from "navigation-common/SecurityService";

async function loadOptions(inputValue: string, callback: (options: OptionsType) => void): Promise<void> {
    const pages = await confluenceService.searchPages(inputValue);
    callback(pages.map(page => ({
        value: page.link,
        label: `${ page.title } (${ page.spaceName })`,
    })));
}

interface ConfluenceLinkAutocompleteProps extends ExtendedFieldProps<string>{
    setIsAutocompleteOpen: (state: boolean) => void,
}

export function ConfluenceLinkAutocomplete(fieldProps: ConfluenceLinkAutocompleteProps) {
    const [isUrl, setIsUrl] = useState<boolean>(false);
    const elementRef = useRef<HTMLInputElement>(null);

    function onInputChange(newValue: string, actionMeta: InputActionMeta): void {
        if (actionMeta.action === "input-change") {
            const isValid = SecurityService.isValidUrl(newValue.toLowerCase());
            if (isValid) {
                fieldProps.onChange(newValue);
            }
            setIsUrl(isValid);
        }
    }

    function onSelect(value: ValueType<OptionType, false>, action: ActionMeta): void {
        if (action.action === "clear") {
            fieldProps.onChange("");
            return;
        }
        if (value) {
            fieldProps.onChange(value.value as string);
            elementRef.current?.blur();
        }
    }

    return <AsyncSelect
        // @ts-ignore
        ref={ elementRef }
        { ...fieldProps }
        value={fieldProps.value ? {value: fieldProps.value, label: fieldProps.value} : undefined}
        placeholder={ "Search for Confluence page or enter URL" }
        menuIsOpen={ isUrl ? false : undefined }
        onMenuOpen={() => fieldProps.setIsAutocompleteOpen(true)}
        onMenuClose={() => fieldProps.setIsAutocompleteOpen(false)}
        loadOptions={ loadOptions }
        onInputChange={ onInputChange }
        onChange={ onSelect }
        noOptionsMessage={ () => "No pages found (external links must start with \"http(s)://\")" }
        autoFocus
        isClearable
    />;
}
